// src/constants/teamConstants.js

/**
 * Team role definitions for project members
 */
export const TEAM_ROLES = [
    { value: 'project_manager', label: 'Project Manager' },
    { value: 'team_lead', label: 'Team Lead' },
    { value: 'team_member', label: 'Team Member' },
    { value: 'client', label: 'Client' },
    { value: 'stakeholder', label: 'Stakeholder' },
    { value: 'observer', label: 'Observer' }
  ];
  
  /**
   * Default permissions for new team members
   */
  export const DEFAULT_PERMISSIONS = {
    canEdit: false,
    canManageTasks: true,
    canComment: true,
    canViewFiles: true
  };
  
  /**
   * Default new member object structure
   */
  export const DEFAULT_NEW_MEMBER = {
    user: '',
    role: 'team_member',
    permissions: { ...DEFAULT_PERMISSIONS }
  };